import { Bbox } from '@typings/reality-capture/common';
import { CoordsUtils, NorthingEasting } from '@shared/utils/CoordsUtils';
import { MathUtils } from '@shared/utils/MathUtils';
import { Vector3 } from '@math.gl/core';

interface CrossSectionCoordsMeta {
    area: number[][];
    startVector: Vector3;
    endVector: Vector3;
    mercatorDistortion: number;
}

export async function crossSectionCoordsMeta(
    startCoord: NorthingEasting,
    endCoord: NorthingEasting,
    rectangleWidth: number = 0.1
): Promise<CrossSectionCoordsMeta> {
    const startLatLon = CoordsUtils.projectCoordinateToWgs84(startCoord);
    const endLatLon = CoordsUtils.projectCoordinateToWgs84(endCoord);

    const startMercator = CoordsUtils.wgs84ToWebMercator(startLatLon);
    const endMercator = CoordsUtils.wgs84ToWebMercator(endLatLon);
    const startVector = new Vector3(startMercator.e, startMercator.n, startMercator.z);
    const endVector = new Vector3(endMercator.e, endMercator.n, endMercator.z);

    const area: number[][] = MathUtils.getRectangleAroundLine2D(
        [startMercator.e, startMercator.n],
        [endMercator.e, endMercator.n],
        rectangleWidth
    );

    const centerLatitude = (startLatLon.lat + endLatLon.lat) / 2;
    const mercatorDistortion: number = CoordsUtils.calculateMercatorDistortionFromLatitude(centerLatitude);

    return { area, startVector, endVector, mercatorDistortion };
}

export function areaToBbox(area: number[][]): Bbox {
    const minX = Math.min(...area.map(p => p[0]));
    const maxX = Math.max(...area.map(p => p[0]));
    const minY = Math.min(...area.map(p => p[1]));
    const maxY = Math.max(...area.map(p => p[1]));
    const bbox: Bbox = [minX, minY, maxX, maxY];
    return bbox;
}